import type { LevelDefinition } from '../levels/LevelDefinition';
import type { Mission } from './MissionSystem';

export class LevelSystem implements ILevelSystem {
  private currentLevel: string = '';
  private levelData: LevelDefinition | null = null;

  loadLevel(levelId: string, data: LevelDefinition): void {
    this.currentLevel = levelId;
    this.levelData = data;
  }

  getCurrentLevel(): string {
    return this.currentLevel;
  }

  checkVictory(playerState: { x: number }, missions: Mission[]): boolean {
    if (!this.levelData) return false;

    const allMissionsComplete = this.levelData.missions.every((m) => {
      const mission = missions.find((mis) => mis.id === m.id);
      return mission && mission.isComplete();
    });

    const reachedEnd = playerState.x >= (this.levelData.exitX ?? this.levelData.width - 150);

    // GDD: victory requires BOTH missions complete AND reaching exit.
    return allMissionsComplete && reachedEnd;
  }

  checkDefeat(playerState: { hp: number }): boolean {
    return playerState.hp <= 0;
  }

  activateCheckpoint(_checkpointX: number, _checkpointY: number): void {
    // Handled by GameScene via playerLogic.updateCheckpoint()
  }
}

export interface ILevelSystem {
  loadLevel(levelId: string, data: LevelDefinition): void;
  getCurrentLevel(): string;
  checkVictory(playerState: { x: number }, missions: import('./MissionSystem').Mission[]): boolean;
  checkDefeat(playerState: { hp: number }): boolean;
  activateCheckpoint(checkpointX: number, checkpointY: number): void;
}
